<script setup>
const props = defineProps({
    type: {
        type: String,
        default: "52week",
    },
    current: { type: Number, default: null },
    high: { type: Number, default: null },
    low: { type: Number, default: null },
    avg: { type: Number, default: null },
    chartColors: {
        type: Object,
        default: () => ({
            primary: "#0477D1",
            secondary: "#6D737A",
            emptybar: "#F6F6F6",
            current: "#333333",
            border: "#E3E3E3",
        }),
    },
});

const emit = defineEmits(["mouseover", "mouseleave"]);

function getBarWidth(value, max) {
    if (max === 0) return "0%";
    return `${(value / max) * 100}%`;
}
</script>

<template lang="pug">
.qmodii-bar-stack-wrapper(
    v-if="type !== 'volume'",
    @mouseover="emit('mouseover', $event)",
    @mouseleave="emit('mouseleave', $event)"
)
    .qmodii-bar-stack
        .qmodii-start-tick.qmodii-bar-separator(
            :style="{ backgroundColor: props.chartColors.border }"
        )
        .qmodii-bar-primary.qmodii-bar(
            :style="{ width: getBarWidth(props.current - props.low, props.high - props.low), backgroundColor: props.chartColors.primary }"
        )
        .qmodii-current-tick.qmodii-bar-separator(
            :style="{ backgroundColor: props.chartColors.current }"
        )
        .qmodii-bar-empty.qmodii-bar(
            :style="{ width: getBarWidth(props.high - props.current, props.high - props.low), backgroundColor: props.chartColors.emptybar }"
        )
        .qmodii-end-tick.qmodii-bar-separator(
            :style="{ backgroundColor: props.chartColors.border }"
        )
.qmodii-bar-stack-wrapper(
    v-else,
    @mouseover="emit('mouseover', $event)",
    @mouseleave="emit('mouseleave', $event)"
)
    .qmodii-bar-stack
        .qmodii-start-tick.qmodii-bar-separator(
            :style="{ backgroundColor: props.chartColors.border }"
        )
        .qmodii-bar-secondary.qmodii-bar(
            :style="{ width: getBarWidth(props.avg, Math.max(props.current, props.avg)), backgroundColor: props.chartColors.secondary }"
        )
        .qmodii-current-tick.qmodii-bar-separator(
            :style="{ backgroundColor: props.chartColors.current }"
        )
        .qmodii-bar-empty.qmodii-bar(
            :style="{ width: getBarWidth(Math.max(props.current, props.avg) - props.avg, Math.max(props.current, props.avg)), backgroundColor: props.chartColors.emptybar }"
        )
        .qmodii-end-tick.qmodii-bar-separator(
            v-if="props.avg <= props.current",
            :style="{ backgroundColor: props.chartColors.border }"
        )
    .qmodii-bar-stack
        .qmodii-start-tick.qmodii-bar-separator(
            :style="{ backgroundColor: props.chartColors.border }"
        )
        .qmodii-bar-primary.qmodii-bar(
            :style="{ width: getBarWidth(props.current, Math.max(props.current, props.avg)), backgroundColor: props.chartColors.primary }"
        )
        .qmodii-current-tick.qmodii-bar-separator(
            :style="{ backgroundColor: props.chartColors.current }"
        )
        .qmodii-bar-empty.qmodii-bar(
            :style="{ width: getBarWidth(Math.max(props.current, props.avg) - props.current, Math.max(props.current, props.avg)), backgroundColor: props.chartColors.emptybar }"
        )
        .qmodii-end-tick.qmodii-bar-separator(
            v-if="props.current <= props.avg",
            :style="{ backgroundColor: props.chartColors.border }"
        )
</template>

<style lang="stylus">
.qmodii-bar-stack-wrapper
    display flex
    flex-direction column
    gap var(--qmodii-spacing-sm)
    height 100%
    width 100%

    .qmodii-bar-stack
        display flex
        align-items center
        width 100%
        height 8px

    .qmodii-bar
        height 100%
        width 100%

    .qmodii-bar-empty
        border-top 1px solid var(--qmodii-border-color, #E3E3E3)
        border-bottom 1px solid var(--qmodii-border-color, #E3E3E3)

    .qmodii-bar-separator
        height 16px
        width 3px
</style>
